module.exports = __webpack_public_path__ + "img/executor.d584c928.svg";